export function getExternalPromoBoxes (item) {
  if (!window.theme.settings.bookDetailsSettings) return

  if (!window.theme.settings.bookDetailsSettings.promo_boxes_api_url) return

  let promoURL = window.theme.settings.bookDetailsSettings.promo_boxes_api_url

  if (promoURL.includes('{ISBN13}') && item.isbn13) {
    promoURL = promoURL.replace('{ISBN13}', item.isbn13)
  }

  if (!document.querySelector('.js-promo-boxes')) return

  const promoBoxesWrapper = document.querySelector('.js-promo-boxes')

  fetch(promoURL).then(resp => resp.json()).then((promos) => {
    promos.forEach((promo) => {
      if (!promo.acf) {
        return
      }
      const data = promo.acf
      if (!data.promo_url && !data.promo_image) {
        return
      }
      const promoImg = data.promo_image
      const promoUrl = data.promo_url
      if (!promoImg.url && !promoUrl.url) {
        return
      }
      const promoTitle = promoImg.alt ? promoImg.alt : item.title
      promoBoxesWrapper.innerHTML += `<div class="promo-box"><a href="${promoUrl.url}" target="_blank" title="${promoTitle}"><img src=${promoImg.url} alt="${promoTitle}"></a></div>`
    })
  })

  return promoBoxesWrapper
}
